module.exports = __webpack_public_path__ + "img/MEDIA073.03667214.jpg";